import React, { useState } from "react";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const images = [
    "14.jpg",
    "15.jpg",
    "16.jpg",
    "1.jpeg",
    "2.jpeg",
    "3.jpeg",
    // "4.jpeg",
    // "5.jpg",
    // "6.png",
    // "7.jpg",
    "8.jpg",
    "9.jpg",
    // "11.jpg",
    "13.jpg",
    "17.jpg",
    "18.jpg",
    "19.jpg"
  ];

  const handleThumbnailClick = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="container-xxl py-5 mt-5 gallery">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-12 col-md-12">
            {/* Lightbox */}
            {isOpen && (
              <Lightbox
                mainSrc={`../../img/gallery/${images[photoIndex]}`}
                nextSrc={`../../img/gallery/${images[(photoIndex + 1) % images.length]}`}
                prevSrc={`../../img/gallery/${images[(photoIndex + images.length - 1) % images.length]}`}
                onCloseRequest={() => setIsOpen(false)}
                onMovePrevRequest={() =>
                  setPhotoIndex((photoIndex + images.length - 1) % images.length)
                }
                onMoveNextRequest={() =>
                  setPhotoIndex((photoIndex + 1) % images.length)
                }
              />
            )}

            {/* Thumbnails */}
            <div className="row g-2 pt-2">
              {images.map((img, index) => (
                <div className="col-4" key={index}>
                  <img
                    className="img-fluid bg-light p-1"
                    src={`../../img/gallery/${img}`}
                    onClick={() => handleThumbnailClick(index)}
                    alt={`Gallery ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
